import get from 'lodash/get'

import isEmpty from 'is-empty'

const getAuthState = state => get(state, 'auth', {})
export const getUser = state => get(getAuthState(state), 'user', {})
const getString = (value) => (String(typeof value) !== 'string' ? '' : value.trim())
export const getUserBrokerId = state => get(getUser(state), 'brokerId', null)
export const getUserBrokerName = state => get(getUser(state), 'brokerName', '')
export const getUserEmail = state => get(getUser(state), 'email', '')
export const getUserFirstName = state => getString(get(getUser(state), 'firstName', ''))
export const getUserId = state => get(getUser(state), 'id', null)
export const getUserLastName = state => getString(get(getUser(state), 'lastName', ''))
export const getUserPhone = state => getString(get(getUser(state), 'phone', ''))
export const getUserPhoneExt = state => getString(get(getUser(state), 'phoneExt', ''))
export const getUserTitle = state => getString(get(getUser(state), 'title', ''))
export const getUserUsername = state => get(getUser(state), 'username', '')

const getUserRole = state => get(getUser(state), 'role', '')

export const getUserType = state => getUserRole(state).split(':').shift()
export const isUnderwriter = state => getUserRole(state).includes('underwriter')

export const isLoading = state => get(getAuthState(state), 'isLoading', false)
export const isAuthenticated = state => get(getAuthState(state), 'isAuthenticated', false)

export const hasIncompleteProfile = state => [getUserFirstName, getUserLastName, getUserPhone]
  .map(selector => selector(state))
  .some(isEmpty)
